import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useFormatter, useTranslations } from "next-intl";
import { I18nLegacy, UiLegacy } from "@silvertours/front-legacy-shared";
import { AverageRating, SummaryContainer } from "./Reviews.styles";
var important = I18nLegacy.important;
var FeedbackSummary = function(param) {
    var averageRating = param.averageRating, count = param.count, _hideSummaryDescription = param.hideSummaryDescription, hideSummaryDescription = _hideSummaryDescription === void 0 ? false : _hideSummaryDescription, _locationName = param.locationName, locationName = _locationName === void 0 ? "" : _locationName;
    var format = useFormatter();
    var t = useTranslations("features.trustLegacy.feedback.feedbackGroup");
    var title = t("title.seo");
    var description = t("description");
    var descriptionLocation = t.rich("descriptionLocation", {
        locationName: locationName,
        important: important
    });
    var reviewCountLabel = t.rich("reviewCountLabel", {
        count: format.number(count, {
            useGrouping: "auto"
        }),
        important: important
    });
    var averagePercentLabel = t("averagePercentLabel");
    return /*#__PURE__*/ _jsxs(SummaryContainer, {
        children: [
            /*#__PURE__*/ _jsx(UiLegacy.SectionTitle, {
                children: title
            }),
            !hideSummaryDescription && /*#__PURE__*/ _jsxs(AverageRating, {
                children: [
                    /*#__PURE__*/ _jsx(UiLegacy.CalloutText, {
                        children: locationName ? descriptionLocation : description
                    }),
                    /*#__PURE__*/ _jsx(UiLegacy.PlainText, {
                        children: reviewCountLabel
                    }),
                    /*#__PURE__*/ _jsxs(UiLegacy.PlainText, {
                        children: [
                            /*#__PURE__*/ _jsx(UiLegacy.Rating, {
                                value: averageRating
                            }),
                            averagePercentLabel
                        ]
                    })
                ]
            })
        ]
    });
};
export { FeedbackSummary };
